import React from "react";
import { connect } from "react-redux";
import { Table, TableBody } from "@material-ui/core";
import { compose } from "recompose";
import RelatedServiceProviderTableHeader from "./RelatedServiceProviderTableHeader";
import RelatedServiceProviderTableEmptyRow from "./RelatedServiceProviderTableEmptyRow";
import RelatedServiceProviderTableRow from "./RelatedServiceProviderTableRow";
import { userRelatedServiceProvidersSelector } from "../../../redux/selectors";

const RelatedServiceProvidersTable = ({ serviceProviders }) => {
  return (
    <Table>
      <RelatedServiceProviderTableHeader />
      <TableBody>
        {!!serviceProviders?.length &&
          serviceProviders.map((serviceProvider, index) => {
            return (
              <RelatedServiceProviderTableRow
                key={`service-provider-related-serviceProvider-${index}`}
                serviceProvider={serviceProvider}
              />
            );
          })}
        {!serviceProviders?.length && <RelatedServiceProviderTableEmptyRow />}
      </TableBody>
    </Table>
  );
};

const mapStateToProps = (state) => ({
  serviceProviders: userRelatedServiceProvidersSelector(state),
});

const enhance = compose(connect(mapStateToProps, undefined));

export default enhance(RelatedServiceProvidersTable);
